

import Home from './Home'
import About from './About'
const views = {
  Home,
  About
}
export default views
